import {
  Box,
  Center,
  Text,
  Link
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Apply() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >

        <Center>
          <Box
            w={{ base: "full", md: "4xl", xl: "6xl" }}
            pt={{ base: 20 }}
          >
            <SectionHeading
              title="Apply"
            />

            <Text
              pt={10}
              pb={{base:40,md:60}}
              px={{ base: 4 }}
              fontSize={{ base: "1.3em", md: "1.5em", lg:"1.7",xl:"2em" }}
              >
              <Lang text="If you are an officially enrolled student in a university program in data science, data engineering, artificial intelligence or similar, and you are facing economic difficulties, go to" /> &nbsp;

              <Link
                href="/apply"
                className="barlow-black"
              >
                <Text as={'span'} color={"#4aeade"}>
                  <Lang text="HOW TO APPLY" />
                </Text>
              </Link>.
            </Text>

          </Box>
        </Center>
      </Box>

    </>
  );
}